

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchData, handleFilter, handleGetDataByPost, handleUpdateItem } from "../../utils/data";
import { Booking, PaginationType } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchAllBookStays = createAsyncThunk("get/AllBookStays", async (page:number) => {
    const data = await fetchData(`BookPlace/getAllBookStays?lang=${lang}&page=${page}`, true, true);
    return data;
}); 

export const fetchBookingsCount = createAsyncThunk("get/BookingsCount", async () => {
    const data = await fetchData(`BookPlace/getBookingsCount`, true);
    return data;
});
export const fetchAllBookHalls = createAsyncThunk("get/AllBookHalls", async (page:number) => {
    const data = await fetchData(`BookHall/getAllBookHalls?lang=${lang}&page=${page}`, true, true);
    return data;
});
export const ReportForBookings = createAsyncThunk("get/AllBookHalls", async (Data:any) => {
    const data = await handleGetDataByPost(Data,`Report/ReportForBookings`, "Post");
    return data;
});


export const changeWaitingBook = createAsyncThunk("PUT/Book", async (bookId) => {
    await handleUpdateItem("", `BookPlace/changeWaitingBook?bookId=${bookId}`, "PUT");
});
export const filterAdminPlaces = createAsyncThunk("post/filterAdminPlaces", async ({placeData,page}:{placeData: any,page:number}) => {
    const response = await handleFilter(placeData, `BookPlace/filterBooks?lang=${lang}&page=${page}`, "POST");
    return response;
});
export const filterAdminHalls = createAsyncThunk("post/filterAdminHalls", async ({placeData,page}:{placeData: any,page:number}) => {
    const response = await handleFilter(placeData, `BookHall/filterBooks?lang=${lang}&page=${page}`, "POST");
    return response;
});
interface bookingState {
    stayBookings: Booking[];
    hallbookings: Booking[];
    bookingsCount:any;
    filterBookingResult: Booking[];
    pagination: PaginationType | null;
    loading: boolean;
    error: string;
}

const initialState: bookingState = {
    stayBookings: [],
    hallbookings: [],
    pagination: null,
    bookingsCount:null,
    filterBookingResult: [],
    loading: false,
    error: ""
};

const adminBookingSlice = createSlice({
    name: "adminBookingSlice",
    initialState,
    reducers: {
        clearFilterResults: (state) => {
            state.filterBookingResult = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBookingsCount.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchBookingsCount.fulfilled, (state, action) => {
                state.loading = false;
                state.bookingsCount = action.payload;
            })
            .addCase(fetchAllBookStays.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchAllBookStays.fulfilled, (state, action) => {
                state.loading = false;
                state.stayBookings = action.payload.data;
                state.pagination = action.payload.pagination;
            })

            .addCase(fetchAllBookHalls.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchAllBookHalls.fulfilled, (state, action) => {
                state.loading = false;
                state.hallbookings = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(filterAdminPlaces.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(filterAdminPlaces.fulfilled, (state, action) => {
                state.loading = false;
                state.filterBookingResult = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(filterAdminHalls.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(filterAdminHalls.fulfilled, (state, action) => {
                state.loading = false;
                state.filterBookingResult = action.payload.data;
                state.pagination = action.payload.pagination;
            })


    }
});
export const { clearFilterResults } = adminBookingSlice.actions;
export default adminBookingSlice.reducer;
